import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-emp-leave-entry',
  templateUrl: './emp-leave-entry.component.html',
  styleUrls: ['./emp-leave-entry.component.scss']
})
export class EmpLeaveEntryComponent implements OnInit {

  employeeCode: string = '';
  leaveDate: Date | null = null;
  leaveTypes = [
    { label: 'CL', value: 'CL' },
    { label: 'EL', value: 'EL' },
    { label: 'LOP', value: 'LOP' },
    { label: 'OD', value: 'OD' }
  ];
  selectedLeaveType: string | null = null;
minFromDate: string = '';
maxToDate: string = '';
  constructor(private route: ActivatedRoute,private http: HttpClient, public appservice: AppService) { }
public add: any = {}; 
  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
    const code = params['Code'];
    //console.log(code);

    // Set into form field
   
      this.add.employeeCode = code;
      this.Get_Latest_date_for_User();
   
  });
  }
  formatDate(date: Date): string {
  return date.toISOString().split('T')[0]; // yyyy-MM-dd
}
Get_Latest_date_for_User(){
  this.appservice.get("Api/Attendance/Get_Latest_Date_forUser?Emp_code=" + this.add.employeeCode).subscribe((res: any) => {
    const data = res;
    if(data) {
      let nextDate = new Date(data[0].lastdate);
      let CL = data[0].CL_REMAINING;
      let EL = data[0].EL_REMAINING;
      console.log('data:', data);
        // ✅ Add 1 day properly
         this.minFromDate = this.formatDate(nextDate);
        nextDate.setDate(nextDate.getDate() + 1);

        this.add.leaveDate = nextDate;
        this.add.CL_REMAINING = CL;
        this.add.EL_REMAINING = EL;
    
        this.add.Fromdate = new Date(nextDate); // Set Fromdate to the same next date
    }
  });
  const today = new Date();
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  this.maxToDate = this.formatDate(endOfMonth);
}
  saveEntry(): void {
    const employeeCode = this.add.employeeCode?.trim();
    const leaveDate = this.add.leaveDate;
    const leaveType = this.add.selectedLeaveType;
    const Fromdate = this.add.Fromdate;
    const Todate = this.add.Todate;
    console.log(localStorage.getItem('User_Data'));
    const username = localStorage.getItem('User_Data') ? JSON.parse(localStorage.getItem('User_Data')).UM_User_Name : 'Unknown';
    if(leaveType === 'OD') {
      if (!employeeCode || !leaveType || !this.add.Fromdate || !this.add.Todate) {
        alert('Please fill all fields before saving.');
        return;
      }
      const payload = {
      employeeCode,
      Fromdate,
      Todate,
      leaveType,username
    };
 this.http.post(this.appservice.Server_URL + 'api/Attendance/insert_Attendance_Master_Range', payload, { headers: this.appservice.headers })
        .subscribe(
          (response) => {            console.log('Employee data saved successfully:', response);
          },
          (error) => {
            console.error('Error saving employee data:', error);
            alert('An error occurred while saving the leave entry.');
          }
        );


    } else {
      
    if (!employeeCode || !leaveDate || !leaveType) {
      alert('Please fill all fields before saving.');
      return;
    }
    if(this.add.CL_REMAINING<=0 && leaveType=='CL'){
      alert('The No of CL Reached Limit.');
      return;
    }
    if(this.add.EL_REMAINING<=0 && leaveType=='EL'){
      alert('The No of EL Reached Limit.')
      return;
    }
    const payload = {
      employeeCode,
      leaveDate,
      leaveType,username,
      IsHalfDay: this.add.IsHalfDay || 1 // Default to 0 if not set
    };
 this.http.post(this.appservice.Server_URL + 'api/Attendance/insert_Attendance_Master', payload, { headers: this.appservice.headers })
        .subscribe(
          (response) => {            console.log('Employee data saved successfully:', response);
          },
          (error) => {
            console.error('Error saving employee data:', error);
            alert('An error occurred while saving the leave entry.');
          }
        );

      }

    //console.log('Leave entry saved:', payload);
    alert('Leave entry saved successfully.');

    this.resetForm();
    this.appservice.back();
  }

  cancelEntry(): void {
    this.resetForm();
    this.appservice.back();
  }

  private resetForm(): void {
    this.add.employeeCode = '';
    this.add.leaveDate = null;
    this.add.selectedLeaveType = null;
  }

}
